// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZNY6","left":"styles_left__1_YGt"};